<template>
  <div class="campaign-card-body-progress">
    <BaseProgressLiner
      :current-value="currentValue"
      :goal="goal"
      :extra-goal1="extraGoal1"
      :extra-goal2="extraGoal2"
    />
  </div>
</template>

<script>
import BaseProgressLiner from '@/components/BaseProgressLiner';

export default {
  name: 'CampaignCardBodyProgress',
  components: {
    BaseProgressLiner,
  },
  props: {
    currentValue: {
      ...BaseProgressLiner.props.currentValue,
    },
    goal: {
      ...BaseProgressLiner.props.goal,
    },
    extraGoal1: {
      ...BaseProgressLiner.props.extraGoal1,
    },
    extraGoal2: {
      ...BaseProgressLiner.props.extraGoal2,
    },
  },
};
</script>
